<template>
  <div class="nav">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="nav">
      <el-tab-pane :key="index" v-for="(item, index) in list" :label="item.name" :name="String(index)"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getTabIndex } from "@/utils/index.js"
export default {
  data() {
    return {
      activeName: "0",
      list: [],
    };
  },
  props: ['navList'],
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      this.$emit('tabClick', this.list[this.activeName])
      this.$store.commit('setTabIndex', { ...this.$store.state.objectId, index: tab.index })

      // this.$emit('tabClick',tab)
    },

  },
  created() {
    const tabIndex = getTabIndex({ ...this.$store.state.objectId })?.index || 0
    this.activeName = tabIndex + ''
  },
  watch: {
    navList(e) {
      // console.log(e);
      this.list = e
    }
  }
};
</script>

<style>
.nav {
  /* margin-top: 15px ; */
  /* padding-top: 15px;
    padding-left: 15px; */
  background: #fff;
}

.nav .el-tabs__nav-scroll {
  padding-left: 25px;
}

.nav .el-tabs__item is-top {
  cursor: pointer;
}

.nav .el-tabs__item.is-active {
  color: #409eff;
}

.nav /deep/.el-tabs__nav-warp::after {
  position: static !important;
}

.nav .el-tabs__item {
  padding: 0 20px;
  height: 45px;
  box-sizing: border-box;
  line-height: 45px;
  display: inline-block;
  list-style: none;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  position: relative;
  background: none;
  border-left: none !important;
  /* font-size: 16px !important; */
  border-radius: 0 !important;
}

.nav .el-tabs__header {
  border-bottom: 1px solid #fff !important;
  background: #fff;
}

.nav .el-tabs__item.is-active {
  background: none !important;
}
</style>

<style scoped>
.nav {
  height: 45px;
}

.nav li {
  cursor: pointer;
}
</style>